module.exports = __webpack_public_path__ + "static/img/security.f4738d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/security.png
// module id = pjLr
// module chunks = 1